export default __webpack_public_path__ + "static/media/stuart-marshall-2016-contributions.e8ea1826.png";